import { CanMatchFn, Router, Routes } from "@angular/router";
import { inject, Injectable } from "@angular/core";

import { ErrorComponent, NotFoundComponent, AboutComponent } from "./pages";
import { SelfServMetaCacheService } from "./shared";

export const canMatchQna: CanMatchFn = () => {
  return inject(CanMatchQna).canMatch();
};

@Injectable()
export class CanMatchQna {
  private readonly cache = inject(SelfServMetaCacheService);
  private readonly router = inject(Router);

  canMatch(): boolean {
    if (this.cache.meta) {
      return true;
    }

    console.warn("selfserv meta data is is undefined");

    let errorRoute = "404";
    if (this.cache.errorStatus === 400 || this.cache.errorStatus >= 500) {
      errorRoute = "error";
    }

    void this.router.navigate([errorRoute], { skipLocationChange: true });
    return false;
  }
}

export const routes: Routes = [
  {
    path: "error",
    component: ErrorComponent,
  },
  {
    path: "about",
    component: AboutComponent,
  },
  {
    path: "404",
    component: NotFoundComponent,
  },
  {
    path: "",
    canMatch: [canMatchQna],
    loadChildren: () => import("./pages/+qna/qna.routes").then((m) => m.routes),
  },
];
